import MuiAccordionSummary from '@mui/material/AccordionSummary'
import { FC } from 'react'

import { AccordionSummaryProps } from './accordion-summary.types'

export const AccordionSummary: FC<AccordionSummaryProps> = ({ children, ...props }) => {
  return <MuiAccordionSummary {...props}>{children}</MuiAccordionSummary>
}
